export default __webpack_public_path__ + "static/media/observationIcon.2213c868.png";